import React from 'react';
import '../stylesheets/bot-item.css';
import { DataTable } from 'primereact/datatable';
import { InputSwitch } from 'primereact/inputswitch';
import { Column } from 'primereact/column';
import { ReactComponent as Edit } from '../../../../svg/edit.svg';
import { ReactComponent as Delete } from '../../../../svg/delete.svg';
import { CustomButton } from '../../../../components/CustomButton';
import { Text } from '../../../../components/Text';
import { BotflowName } from './column-templates/BotflowName';
import PatternQr from './PatternQr';
import { updateBotflowDetails } from '../../../../reducers/wca/botflow/botflow-action';
import { useDispatch } from 'react-redux';
import { buildWcaBotFlowPayload } from '../../botflow-utils';

export const BotListTable = ({
  botflowsData = [],
  handleEditClick,
  handleDeleteClick,
}) => {
  const dispatch = useDispatch();

  const handleSwitchToggle = async (botflow) => {
    try {
      const updatedData = buildWcaBotFlowPayload(botflow, {
        isEnabled: !Boolean(botflow?.isEnabled),
      });
      await dispatch(updateBotflowDetails({ id: botflow.id, updatedData })).unwrap();
    } catch (error) {
      console.error('Error updating bot flow:', error);
    }
  };

  const enableDisableTemplate = (bflow) => (
    <InputSwitch
      checked={Boolean(bflow?.isEnabled)}
      onChange={() => handleSwitchToggle(bflow)}
      className={`${Boolean(bflow?.isEnabled) ? 'custom-enabled' : ''}`}
    />
  );

  return (
    <DataTable
      value={botflowsData}
      dataKey="id"
      className="skalebot-table"
      tableStyle={{ minWidth: '60rem' }}
    >
      <Column
        header="S.No."
        body={(_, options) => options.rowIndex + 1}
        className="text-sm font-normal"
      />

      <Column
        field="name"
        header="Flow Name"
        body={(bflow) => <BotflowName bflow={bflow} />}
        className="text-sm font-normal"
      />

      <Column
        field="activeVersion"
        header="Active Version"
        className="text-sm font-normal"
        body={(bflow) => bflow?.activeVersion ?? '--'}
      />

      <Column
        header="QR Code"
        className="text-sm font-normal"
        body={(bflow) =>
          bflow?.rootNode?.pattern ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-start',
              }}
            >
              <PatternQr
                pattern={bflow.rootNode.pattern}
                showQr={false}
                showDownload={true}
                bflow={bflow}
              />
            </div>
          ) : (
            '-'
          )
        }
      />

      <Column
        header="Status"
        className="text-sm font-normal"
        body={(bflow) => (
          <div className={`flex-nowrap fStatus-${bflow.status}`}>
            <Text>{bflow.status}</Text>
          </div>
        )}
      />

      <Column
        header="Enable/Disable"
        className="text-sm font-normal"
        body={enableDisableTemplate}
      />

      <Column
        header="Actions"
        body={(bflow) => (
          <div className="flex justify-content-start align-items-center gap-1">
            <CustomButton varient="text" icon={<Edit />} onClick={() => handleEditClick(bflow)} />
            <CustomButton
              varient="text"
              icon={<Delete />}
              onClick={() => handleDeleteClick(bflow.id)}
            />
          </div>
        )}
      />
    </DataTable>
  );
};

